import { createStyles } from '@material-ui/core/styles'

export default theme =>
  createStyles({
    '@global': {
      body: {
        backgroundColor: theme.colors.pageBackground,
        minWidth: 320
      }
    },
    root: {
      width: '100%',
      padding: '30px 60px'
    },
    title: {
      color: theme.palette.primary.main,
      fontWeight: 600,
      fontSize: 100,
      textAlign: 'center',
      marginTop: '1em'
    },
    info: {
      color: theme.colors.black,
      fontSize: 20,
      textAlign: 'center'
    }
  })
